export default function () {
  const widgetName = 'fairSponsors';
  const widgetOpts = fairSponsorsOpts;

  return saffire.widgets.sponsors($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    sponsorsInitialized: function () {
      $(`#${widgetName}`).appendTo('.subpage-hoop-container .tier-five')
    },

    scriptPath: widgetOpts.scriptPath,
    timePerSponsor: 2,
    bw: false,
    rotate: true,

  });

}